import { FILTER_TYPE } from '../utils/constants';

class FilterSelection {

    constructor(node, values) {

        node = node || {};

        this.name = node.name;
        this.type = node.type || FILTER_TYPE.default;
        this.comparator = node.operator || node.comparator;
        this.fieldId = node.fieldId && parseInt(node.fieldId);
        this.displayName = node.displayName;
        this.logicalConjunctionOperator = node.logicalConjunctionOperator || 'AND';
        this.values = this.isValuesValid(values) ? values : [
            {
                label: node.displayValue || node.value,
                value: node.value,
            },
        ];

    }

    isValuesValid(values) {

        const isArray = Array.isArray(values);

        if(!isArray || (values && values.length < 1)) {

            return false;

        }

        let isValid = true;
        for(let value of values) {

            if(typeof value.label === 'undefined' || typeof value.value === 'undefined') {

                isValid = false;
                break;

            }

        }

        return isValid;

    }

    addSelectedValue({
        value,
        displayValue,
        label,
    }) {

        this.values.push({
            label: label || displayValue || value,
            value,
        });

    }

    updateFieldProperties(node = {}) {

        this.name = node.name || this.name;
        this.type = node.type || this.type;
        this.comparator = node.operator || node.comparator || this.comparator ;
        this.fieldId = (node.fieldId && parseInt(node.fieldId)) || this.fieldId;
        this.displayName = node.displayName || this.displayName;
        this.logicalConjunctionOperator = node.logicalConjunctionOperator || this.logicalConjunctionOperator;
        this.values = node.values
            ? this.values.map(({ value, label }) => ({
                label: node.values.find((override) => override.value.toString() === value.toString())?.displayValue || label,
                value: value,
            }))
            : this.values;

    }

};

export default FilterSelection;
